import { DropdownIndicatorProps, components } from "react-select";
import { IconSearch } from "../../assets/svgs-index";

const DropdownIndicator: React.FC<DropdownIndicatorProps> = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={IconSearch} alt='icon-search'></img>
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;